import { useCallback, useContext } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { Context } from 'src/Subscribe_'

type FieldValues = {
  is_gift: string | null
}

const IsThisAGiftForSomeoneElse = () => {
  const { dispatch, state } = useContext(Context)

  const { getValues, handleSubmit, register, watch } = useForm<FieldValues>({
    defaultValues: {
      is_gift: state.values.is_gift || null,
    },
  })

  const onSubmit: SubmitHandler<FieldValues> = useCallback((values) => {
    if (values.is_gift !== null) {
      dispatch({
        payload: {
          values: {
            is_gift: values.is_gift,
          },
        },
        type: 'is this a gift for someone else continue clicked',
      })
    }
  }, [])

  const handleBackClick = useCallback(() => {
    const ig = getValues().is_gift
    let v = {}
    if (ig !== null) {
      v = {
        is_gift: ig,
      }
    }
    dispatch({
      payload: {
        values: v,
      },
      type: 'is this a gift for someone else back clicked',
    })
  }, [])

  return (
    <form className="page page3 show" onSubmit={handleSubmit(onSubmit)}>
      <fieldset className="form-item">
        <legend>
          <span>Is this a gift for someone else?*</span>
        </legend>
        <div>
          <div className="yes-or-no-radios" id="edit-is-gift">
            <div className="form-item js-form-type-radio">
              <input
                className="form-radio"
                id="edit-is-gift-1"
                type="radio"
                value="1"
                {...register('is_gift')}
              />
              <label htmlFor="edit-is-gift-1">Yes</label>
            </div>
            <div className="form-item js-form-type-radio">
              <input
                className="form-radio"
                id="edit-is-gift-0"
                type="radio"
                value="0"
                {...register('is_gift')}
              />
              <label htmlFor="edit-is-gift-0">No</label>
            </div>
          </div>
        </div>
      </fieldset>
      <div className="navigation">
        {watch('is_gift') !== null && (
          <button className="continue show" type="submit">
            Continue
          </button>
        )}
        <button className="back show" onClick={handleBackClick} type="button">
          Back
        </button>
      </div>
    </form>
  )
}

export default IsThisAGiftForSomeoneElse
